module.exports = "//public.getcloudapp.com/packs/media/images/arrow-big-d3396313d168780e839a1da60e185a51.png";